import React from 'react';

const VIEW = '0 0 32 32';

function SvgWrap({ size, className, children, ...rest }) {
  return (
    <svg
      viewBox={VIEW}
      width={size}
      height={size}
      className={className}
      role="img"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

/** 밍고알 — tier egg (< 37) */
export function MingoBirdEggSvg({ size = 20, className, uid }) {
  const id = uid || 'egg';
  return (
    <SvgWrap size={size} className={className}>
      <defs>
        <linearGradient id={`${id}-brand`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#DB2777" />
        </linearGradient>
      </defs>
      <ellipse cx="16" cy="17" rx="9" ry="11" fill={`url(#${id}-brand)`} />
      <ellipse cx="12.5" cy="13" rx="2.8" ry="4" fill="#fff" opacity="0.35" />
    </SvgWrap>
  );
}

/** 아기밍고 — tier hatchling (37+) */
export function MingoBirdHatchlingSvg({ size = 20, className, uid }) {
  const id = uid || 'hatch';
  return (
    <SvgWrap size={size} className={className}>
      <defs>
        <linearGradient id={`${id}-brand`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#DB2777" />
        </linearGradient>
      </defs>
      <path
        d="M8 20 L10 14 L13 19 L16 12 L19 19 L22 14 L24 20 Z"
        fill={`url(#${id}-brand)`}
        opacity="0.45"
      />
      <circle cx="16" cy="13" r="7" fill={`url(#${id}-brand)`} />
      <circle cx="13.2" cy="11.8" r="1.2" fill="#fff" />
      <circle cx="18.8" cy="11.8" r="1.2" fill="#fff" />
      <circle cx="13.2" cy="12.1" r="0.55" fill="#1a1a2e" />
      <circle cx="18.8" cy="12.1" r="0.55" fill="#1a1a2e" />
      <path d="M15 15 L17 15 L16 17 Z" fill="#FCD34D" />
    </SvgWrap>
  );
}

/** 밍고 — tier bird (51+) */
export function MingoBirdStandardSvg({ size = 20, className, uid }) {
  const id = uid || 'bird';
  return (
    <SvgWrap size={size} className={className}>
      <defs>
        <linearGradient id={`${id}-brand`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#DB2777" />
        </linearGradient>
      </defs>
      <ellipse cx="10" cy="17" rx="4" ry="6.5" fill={`url(#${id}-brand)`} opacity="0.75" transform="rotate(-22 10 17)" />
      <ellipse cx="22" cy="17" rx="4" ry="6.5" fill={`url(#${id}-brand)`} opacity="0.75" transform="rotate(22 22 17)" />
      <circle cx="16" cy="14" r="8" fill={`url(#${id}-brand)`} />
      <circle cx="13" cy="12.8" r="1.35" fill="#fff" />
      <circle cx="19" cy="12.8" r="1.35" fill="#fff" />
      <circle cx="13" cy="13.1" r="0.6" fill="#1a1a2e" />
      <circle cx="19" cy="13.1" r="0.6" fill="#1a1a2e" />
      <path d="M14.5 16 L17.5 16 L16 18.5 Z" fill="#FCD34D" />
    </SvgWrap>
  );
}

/** 무지개밍고 — tier rainbow (71+) */
export function MingoBirdRainbowSvg({ size = 20, className, uid }) {
  const id = uid || 'rainbow';
  return (
    <SvgWrap size={size} className={className}>
      <defs>
        <linearGradient id={`${id}-rainbow`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="33%" stopColor="#2563EB" />
          <stop offset="66%" stopColor="#10B981" />
          <stop offset="100%" stopColor="#DB2777" />
        </linearGradient>
      </defs>
      <ellipse cx="9.5" cy="17" rx="4.2" ry="6.8" fill={`url(#${id}-rainbow)`} opacity="0.9" transform="rotate(-22 9.5 17)" />
      <ellipse cx="22.5" cy="17" rx="4.2" ry="6.8" fill={`url(#${id}-rainbow)`} opacity="0.9" transform="rotate(22 22.5 17)" />
      <circle cx="16" cy="14" r="8.5" fill={`url(#${id}-rainbow)`} />
      <circle cx="13" cy="12.8" r="1.4" fill="#fff" />
      <circle cx="19" cy="12.8" r="1.4" fill="#fff" />
      <circle cx="13" cy="13.1" r="0.65" fill="#1a1a2e" />
      <circle cx="19" cy="13.1" r="0.65" fill="#1a1a2e" />
      <path d="M14.5 16 L17.5 16 L16 18.8 Z" fill="#FCD34D" />
      <path d="M9 6 Q16 2 23 6" stroke={`url(#${id}-rainbow)`} strokeWidth="1.8" fill="none" />
    </SvgWrap>
  );
}

/** 골든밍고 — tier golden (91+) */
export function MingoBirdGoldenSvg({ size = 20, className, uid }) {
  const id = uid || 'gold';
  return (
    <SvgWrap size={size} className={className}>
      <defs>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FCD34D" />
          <stop offset="100%" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
      <ellipse cx="9.5" cy="17" rx="4.2" ry="6.8" fill={`url(#${id}-gold)`} transform="rotate(-22 9.5 17)" />
      <ellipse cx="22.5" cy="17" rx="4.2" ry="6.8" fill={`url(#${id}-gold)`} transform="rotate(22 22.5 17)" />
      <circle cx="16" cy="14" r="8.5" fill={`url(#${id}-gold)`} />
      <circle cx="13" cy="12.8" r="1.4" fill="#fff" />
      <circle cx="19" cy="12.8" r="1.4" fill="#fff" />
      <circle cx="13" cy="13.1" r="0.65" fill="#1a1a2e" />
      <circle cx="19" cy="13.1" r="0.65" fill="#1a1a2e" />
      <path d="M14.5 16 L17.5 16 L16 18.8 Z" fill="#DB2777" />
      <path
        d="M12 5 L13.5 2.5 L15 5 L16 2 L17 5 L18.5 2.5 L20 5 Z"
        fill={`url(#${id}-gold)`}
        stroke="#F59E0B"
        strokeWidth="0.4"
      />
    </SvgWrap>
  );
}

const TIER_COMPONENTS = [
  MingoBirdEggSvg,
  MingoBirdHatchlingSvg,
  MingoBirdStandardSvg,
  MingoBirdRainbowSvg,
  MingoBirdGoldenSvg,
];

/** @param {{ tierIndex?: number, tierId?: string, size?: number, className?: string }} props */
export function MingoBirdIcon({ tierIndex, tierId, size = 20, className }) {
  const uid = React.useId().replace(/:/g, '');
  let idx = typeof tierIndex === 'number' ? tierIndex : -1;
  if (tierId) {
    const map = { egg: 0, hatchling: 1, bird: 2, rainbow: 3, golden: 4 };
    idx = map[tierId] ?? 0;
  }
  if (idx < 0 || idx >= TIER_COMPONENTS.length) idx = 0;
  const Bird = TIER_COMPONENTS[idx];
  return <Bird size={size} className={className} uid={uid} />;
}

/** Default avatar fallback — 밍고알 */
export function MingoBirdEggAvatar({ size = 28, className }) {
  const uid = React.useId().replace(/:/g, '');
  return (
    <span
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        background: '#f3f4f6',
      }}
      aria-hidden="true"
    >
      <MingoBirdEggSvg size={Math.round(size * 0.85)} uid={`${uid}-av`} />
    </span>
  );
}
